import React from "react";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { Package } from "lucide-react";

export const BlockConvergente = ({
  convergentPackages,
  selectedConvergentId,
  setSelectedConvergentId,
  selectedConvergentPkg,
  fmtC,
  renderBlockHeader,
  openBlocks,
}) => {
  return (
    <div className="border border-[#1E1E5F] rounded-lg overflow-hidden" data-testid="block-A">
      {renderBlockHeader("A", <Package className="h-4 w-4 text-[#03BEE4]" />, "Paquete Convergente")}
      {openBlocks.A && (
        <div className="p-4 space-y-3 bg-[#0A0A35]/30">
          {convergentPackages.length === 0 ? (
            <p className="text-slate-500 text-sm text-center py-3">No hay paquetes convergentes configurados. Créalos desde el Catálogo.</p>
          ) : (
            <>
              <div>
                <Label className="text-slate-300 text-sm">Paquete Convergente</Label>
                <Select
                  value={selectedConvergentId || "__none__"}
                  onValueChange={v => setSelectedConvergentId(v === "__none__" ? "" : v)}
                >
                  <SelectTrigger className="bg-[#0A0A35] border-[#1E1E5F] text-white mt-1 h-9 text-sm" data-testid="convergent-pkg-select">
                    <SelectValue placeholder="Selecciona paquete convergente..." />
                  </SelectTrigger>
                  <SelectContent className="bg-[#0A0A35] border-[#1E1E5F] max-h-60">
                    <SelectItem value="__none__" className="text-slate-400 text-sm">— Sin selección —</SelectItem>
                    {convergentPackages.map(p => (
                      <SelectItem key={p.id} value={p.id} className="text-white text-sm">
                        {p.nombre} — {fmtC(p.precio_total)}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              {selectedConvergentPkg && (
                <div className="bg-[#1B1B4B]/30 rounded-lg p-3 space-y-1">
                  {selectedConvergentPkg.descripcion && (
                    <p className="text-xs text-slate-400 mb-2">{selectedConvergentPkg.descripcion}</p>
                  )}
                  {selectedConvergentPkg.servicios.map((svc, idx) => (
                    <div key={idx} className="flex justify-between text-sm">
                      <span className="text-white">
                        {svc.nombre}{svc.linea_numero ? ` (línea ${svc.linea_numero})` : ""}
                      </span>
                      <span className="text-slate-400 text-xs">{fmtC(svc.precio)}</span>
                    </div>
                  ))}
                  <div className="border-t border-[#1E1E5F] pt-1 mt-1 flex justify-between">
                    <span className="text-slate-400 text-xs">Total paquete:</span>
                    <span className="text-[#42E695] font-semibold text-sm">{fmtC(selectedConvergentPkg.precio_total)}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
